/**
 * GET /projects/{projectId}/development-tasks/{taskId}/release-request
 * 的只读回执缓存键。GET latest 按 task id 读最近一条 LaneRelease。
 */
export function developmentTaskReleaseReceiptKey(taskId: string) {
  return ['development-tasks', taskId, 'release-receipt'] as const
}
